const Config = {
    'base' : 'https://metamax.network',
};

export default Config;




